// Settings that Vandaag needs offline too: kept on the device and sent like any other change.

import { useLiveQuery } from "dexie-react-hooks";
import { getMeta, setMeta } from "./db";
import { sync } from "./sync";

/** Ochtendstand is on unless PK turned it off (V6 AC1). */
export function useMorningMode(): boolean | undefined {
  return useLiveQuery(async () => (await getMeta<boolean>("morningMode")) ?? true);
}

/** The rest screen after bedtime (B49): on unless PK turned it off. */
export function useWindDown(): boolean | undefined {
  return useLiveQuery(async () => (await getMeta<boolean>("windDown")) ?? true);
}

export async function setWindDown(on: boolean): Promise<void> {
  await setMeta("windDown", on);
  await sync.mutate("settings.setWindDown", { on }, [], async () => {});
}

export async function setMorningMode(on: boolean): Promise<void> {
  await setMeta("morningMode", on);
  await sync.mutate("settings.setMorningMode", { on }, [], async () => {});
}
